module.exports = __webpack_public_path__ + "img/giphy.3c130228.gif";